export const NexusRoutes = {
  Accreditation: (accountId: string) => `/investors/investment_accounts/${accountId}/accreditation/`,
  AccreditationDocument: (accountId: string, documentId: string) =>
    `/investors/investment_accounts/${accountId}/accreditation/documents/${documentId}/`,
  AccreditationDocuments: (accountId: string) =>
    `/investors/investment_accounts/${accountId}/accreditation/documents/`,
  AccreditationSubmit: (accountId: string) => `/investors/investment_accounts/${accountId}/accreditation/submit/`,
  Account: (id: string) => `${NexusRoutes.Accounts}${id}/`,
  AccountDocuments: (id: string) => `/investors/investment_accounts/${id}/documents/`,
  AccountHoldings: (id: string) => `${NexusRoutes.Accounts}${id}/holdings/`,
  AccountOrders: (id: string) => `/investors/investment_accounts/${id}/orders/`,
  AccountPaymentMethods: (id: string) => `/investors/investment_accounts/${id}/payment_methods/`,
  Accounts: '/investors/investment_accounts/',
  AccountTransactions: (id: string) => `/investors/investment_accounts/${id}/transactions/`,
  BankAccount: (id: string) => `/investors/investment_accounts/${id}/bank_account/`,
  ContactInformation: (id: string) => `/investors/investment_accounts/${id}/contact_information/`,
  EntityInformation: (id: string) => `/investors/investment_accounts/${id}/entity_information/`,
  GromaCoinClaim: '/gromacoin/claims',
  GromaCoinEcosystemOverview: '/ecosystem_overview',
  GromaCoinOverview: '/gromacoin/overview',
  GromaCoinWaitlist: '/gromacoin/waitlist',
  IdentityVerification: '/users/identity_verifications/latest/',
  IdentityVerificationSync: (verificationId: string) => `/users/identity_verifications/${verificationId}/sync/`,
  InvestmentEligibility: (id: string) => `/investors/investment_accounts/${id}/investment_eligibility/`,
  OnboardingProgress: '/investors/onboarding_progress/',
  Order: (id: string) => `/investors/orders/${id}/`,
  OrderAcknowledgementAccept: (orderId: string, acknowledgementId: string) =>
    `/investors/orders/${orderId}/acknowledgements/${acknowledgementId}/accept/`,
  OrderAcknowledgements: (id: string) => `/investors/orders/${id}/acknowledgements/`,
  OrderAvailablePaymentMethods: (id: string) => `/investors/orders/${id}/available_payment_methods/`,
  OrderDocuments: (id: string) => `/investors/orders/${id}/documents/`,
  OrderFundingAchInitiate: (id: string) => `/investors/orders/${id}/funding/ach/initiate/`,
  OrderFundingAchMandate: (id: string) => `/investors/orders/${id}/funding/ach/mandate/`,
  OrderReview: (id: string) => `/investors/orders/${id}/review/`,
  OrderSubmit: (id: string) => `/investors/orders/${id}/submit/`,
  PaymentMethodDetail: (id: string) => `/investors/payment_methods/${id}/`,
  PaymentMethodSetPreferred: (id: string) => `/investors/payment_methods/${id}/set_preferred/`,
  PlaidBankAccounts: '/investors/plaid/bank_accounts/',
  PlaidLinkToken: '/investors/plaid/link_token/',
  Register: '/users/auth/register/',
  ResendEmailVerification: '/users/auth/resend_email_verification/',
  UpdateBankAccount: (id: string) => `/investors/investment_accounts/${id}/bank_account/`,
  WalletBalance: (id: string) => `/investors/wallets/${id}/balance/`,
};
